window.sanitasApp = window.sanitasApp || {}

/**
 * Handle clik or tap event on the san-teaser in order to trigger the link
 *
 * @param {object} sanitasApp
 * @param {object} window
 * @param {object} document
 */
;(function (sanitasApp, window, document) {
  'use strict'

  var teasers = document.querySelectorAll('.san-teaser')
  var teasersAreAbsent = teasers.length === 0

  if (teasersAreAbsent) {
    return
  }

  prepareElements()

  /**
   * Attach click event to every san-teaser and trigger either the link or the button
   */
  function prepareElements() {
    ;[].forEach.call(teasers, function (teaser) {
      teaser.addEventListener('click', function (event) {
        var href = this.getElementsByTagName('a')[0]
        var sanitasButton = this.querySelector('sanitas-button')

        var hrefAttributeExists =
          href.getAttribute('href') && href.getAttribute('href').length > 0
        var onClickAttributeExists =
          href.getAttribute('onclick') &&
          href.getAttribute('onclick').length > 0
        if (
          href !== undefined &&
          (hrefAttributeExists || onClickAttributeExists)
        ) {
          href.click()
        }
        if (sanitasButton !== null) {
          sanitasButton._onTap(event)
        }
      })
    })
  }
})(window.sanitasApp, window, document)
